import createIcon from '../../createIcon';

/**
 * @component @name HomeWork
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMSAxMVYyMUg2VjE1SDEwVjIxSDE1VjExTDggNkwxIDExWiIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTEwIDNWNC45N0wxNyA5Ljk3VjExSDE5VjEzSDE3VjE1SDE5VjE3SDE3VjIxSDIzVjNIMTBaTTE5IDlIMTdWN0gxOVY5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const HomeWork = createIcon('HomeWork', [
  ['path', { d: 'M1 11V21H6V15H10V21H15V11L8 6L1 11Z', key: 'lbjdya' }],
  [
    'path',
    { d: 'M10 3V4.97L17 9.97V11H19V13H17V15H19V17H17V21H23V3H10ZM19 9H17V7H19V9Z', key: '13rebp' },
  ],
]);

export default HomeWork;
